export default "__VITE_ASSET__g0_kzU4E__"